import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

const SecondaryButton = ({
  title,
  link,
  style,
  state,
  disabled = false,
  onClick,
  active = false, // 👈 NOUVELLE PROP
}) => {
  const [offBtn, setOffBtn] = useState(disabled);

  useEffect(() => {
    setOffBtn(disabled);
  }, [disabled]);

  const baseClasses =
    'px-4 py-3 rounded-lg cursor-pointer border font-medium text-sm text-center transition-colors';

  const activeClasses = active
    ? 'bg-blue-admin text-white border-blue-admin'
    : 'bg-white text-blue-admin border-gray-admin hover:bg-gray-50';

  const disabledClasses = offBtn ? 'opacity-30 cursor-not-allowed' : '';

  const className = twMerge(
    baseClasses,
    activeClasses,
    disabledClasses,
    style
  );

  if (link) {
    return (
      <Link
        to={link}
        state={state}
        className={className}
      >
        {title}
      </Link>
    );
  }

  return (
    <button
      className={className}
      disabled={offBtn}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default SecondaryButton;
